import React, { useEffect, useRef, useState } from "react"
import style from "./HomePage.module.css"
import { NavBarGlobal, ObjectNavbarMenu } from "../../components/Navbar/Navbar"
import {
  faAward,
  faBellConcierge,
  faCashRegister,
  faHouse,
  faLayerGroup,
  faList,
  faMoneyBill,
  faMoneyBill1Wave,
  faPeopleGroup,
  faPlusSquare,
  faProjectDiagram,
  faReceipt,
  faRectangleAd,
  faScroll,
  faSliders,
  faUserCheck,
  faUsers,
  faMotorcycle,
  faCircleQuestion,
  faTicket,
  faGraduationCap,
  faObjectGroup,
  faListCheck,
  faBullhorn,
  faWallet,
  faBell,
  faCalendarCheck,
  faPrint,
  faChartColumn,
  faRobot,
  faCreditCard,
  faFileInvoiceDollar,
  faFileImport,
  faBrain,
  faWandMagicSparkles,
  faStore,
  faExternalLinkAlt,
  faLocationDot,
  faPlugCircleBolt,
  faClock,
  faFingerprint,
  faUserClock,
  faClipboardCheck,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons"
import { faFacebook, faWhatsapp } from "@fortawesome/free-brands-svg-icons"
import MenuLogged from "../../components/MenuLogged/MenuLogged"
import { ProductsPage } from "../Products/Products/ProductsPage"
import { EmployeesPage } from "../MyStore/Employees/EmployeesPage"
import { PATH_MAP } from "../../configuration/PathMap"
import { useReloadMemory } from "../../hooks/useReloadMemory"
import { PromotionsPage } from "../SerivesDir/Promotions/PromotionsPage"
import { AwardsPage } from "../SerivesDir/Awards/AwardsPage"
import { ExtraServicesPage } from "../SerivesDir/ExtraServices/ExtraServicesPage"
import { MyCompanyPage } from "../MyStore/MyCompany/MyCompanyPage"
import { OrderPage } from "../Fluxo/Order/OrderPage"
import { CustomerPage } from "../Fluxo/Customer/CustomerPage"
import { CustomerExitCheckPage } from "../Fluxo/Customer/CustomerExitCheckPage"
import { DailyPage } from "../CashFlow/CashFlow"
import { EmployeeMetricsPage } from "../CashFlow/EmployeeMetricsPage"
import { PayrollSummaryPage } from "../CashFlow/PayrollSummaryPage"
import { MenuMetricsPage } from "../CashFlow/MenuMetricsPage"
import { Navigate, useLocation } from "react-router-dom"
import { useMenuMobileContext } from "../../context/useMenuMobileContext"
import { MobileBottomNavbar } from "../../components/MobileBottomNavbar/MobileBottomNavbar"
import { CategoryPage } from "../Products/Category/CategoryPage"
import { ComboPage } from "../Products/Combo/ComboPage"
import { AdditionalPage } from "../Products/Addtional/AdditionalPage"
import { useTranslation } from "react-i18next"
import CourierPartnersPage from "../Delivery/CourierPartnersPage"
import { Permissions, PermissionsType } from "../../Enum/PermissionsType"
import { HelpCenterPage } from "../MyStore/HelpCenterPage"
import { CouponsPage } from "../SerivesDir/Coupons/CouponsPage"
import { TutorialsPage } from "../Tutorials/TutorialsPage"
import { SelectionPage } from "../Products/Selection/SelectionPage"
import { NoticesPage } from "../SerivesDir/Notices/NoticesPage"
import { PushNotificationsPage } from "../Notifications/PushNotificationsPage"
import { PrintAutomationPage } from "../MyStore/PrintAutomation/PrintAutomationPage"
import { WhatsAppAutomationPage } from "../MyStore/WhatsAppAutomation/WhatsAppAutomationPage"
import { WhatsAppCrmPage } from "../MyStore/WhatsAppCrm/WhatsAppCrmPage"
import { WhatsAppOfficialPage } from "../MyStore/WhatsAppOfficial/WhatsAppOfficialPage"
import { RespostaAiIntegrationPage } from "../MyStore/RespostaAiIntegration/RespostaAiIntegrationPage"
import { AiIntegrationPage } from "../MyStore/AiIntegration/AiIntegrationPage"
import { PlansPage } from "../MyStore/Plans/PlansPage"
import { ReservedOrdersPage } from "../Fluxo/Order/ReservedOrdersPage"
import { ManualExternalOrdersPage } from "../Fluxo/ManualExternalOrders/ManualExternalOrdersPage"
import { useEmployerLogged } from "../../context/useEmployeeContext"
import {
  OWNER_ONBOARDING_START_EVENT,
  OwnerOnboardingTutorial,
} from "../../components/Tutorial/OwnerOnboardingTutorial"
import { OwnerOnboardingIntroModal } from "../../components/Tutorial/OwnerOnboardingIntroModal"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { PostRequest } from "../../services/ApiClientService"
import { Employee } from "../../Objects/Employee/Employee"
import { StoreGroupsPage } from "../MyStore/StoreGroups/StoreGroupsPage"
import { FiscalIntegrationPage } from "../MyStore/FiscalIntegration/FiscalIntegrationPage"
import { FiscalImportsPage } from "../MyStore/FiscalImports/FiscalImportsPage"
import { companyMemory } from "../../Objects/Memory/Memory"
import { CompleteOwnerProfilePopup } from "../../components/Onboarding/CompleteOwnerProfilePopup"
import { ServicePointsPage } from "../Fluxo/ServicePoints/ServicePointsPage"
import { MyTimeClockPage } from "../TimeClock/MyTimeClockPage"
import { TimeClockPage } from "../MyStore/TimeClock/TimeClockPage"
import { TimeClockStatusBar } from "../../components/TimeClock/TimeClockStatusBar"
import { TimeClockStatusProvider, useTimeClockStatus } from "../../context/useTimeClockStatusContext"
import { SystemModuleType } from "../../Enum/SystemModuleType"
import { MyChecklistsPage } from "../Checklist/MyChecklistsPage"
import { ChecklistPage } from "../MyStore/Checklist/ChecklistPage"
import { CompanyModulesPopup } from "../../components/Popups/CompanyModulesPopup/CompanyModulesPopup"
import { useCompanyModulesStatus } from "../../context/useCompanyModulesStatusContext"
import { canAccessRestrictedPage } from "../../utils/employeeAccess"

type PageWithPermission = {
  element: React.ReactNode
  permission?: PermissionsType
  module?: SystemModuleType
  enforceRouteGuard?: boolean
}

export const HomePage: React.FC = () => (
  <TimeClockStatusProvider>
    <HomePageContent />
  </TimeClockStatusProvider>
)

const HomePageContent: React.FC = () => {
  const { t } = useTranslation("pages")

  const { status: timeClockStatus, refresh: refreshTimeClockStatus } = useTimeClockStatus()

  const { handleReloadToMemory } = useReloadMemory()

  const hasLoadedInitialMemory = useRef(false)

  const hasRequestedTimeClockStatusRef = useRef(false)

  const handleReloadToMemoryRef = useRef(handleReloadToMemory)

  useEffect(() => {
    handleReloadToMemoryRef.current = handleReloadToMemory
  }, [handleReloadToMemory])

  const { isNotMobile } = useMenuMobileContext()

  const { userEmployee, setEmployee } = useEmployerLogged()

  const [isOwnerTutorialOpen, setIsOwnerTutorialOpen] = useState(false)

  const [isOwnerOnboardingIntroOpen, setIsOwnerOnboardingIntroOpen] = useState(false)

  const [isModuleSetupOpen, setIsModuleSetupOpen] = useState(false)

  const hasRequestedOwnerTutorialRef = useRef(false)

  const hasRequestedModuleSetupRef = useRef(false)

  const { refresh: refreshCompanyModulesStatus, isModuleEnabled } = useCompanyModulesStatus()

  const requiresOwnerProfile = Boolean(userEmployee?.isMaster && !userEmployee.personEntity.phone?.trim())

  const getPublicStoreLink = () => {
    const publicStoreSlug = companyMemory.slug?.trim() ?? ""

    return publicStoreSlug.length > 0 ? `${API_ROUTES.SITE}${publicStoreSlug}` : ""
  }

  const [publicStoreLink, setPublicStoreLink] = useState(getPublicStoreLink)

  const pages: Record<number, PageWithPermission> = {
    0: { element: <OrderPage key="commands-page" />, permission: Permissions.CanEditeOrders },
    1: { element: <ServicePointsPage key="service-points-page" />, permission: Permissions.CanEditeServicePoints },
    2: { element: <CustomerPage key="customer-page" />, permission: Permissions.CanEditeClients },
    3: { element: <CustomerExitCheckPage key="customer-exit-check-page" />, permission: Permissions.CanEditeClients },
    4: {
      element: <ReservedOrdersPage key="reserved-orders-page" />,
      permission: Permissions.CanEditeOrders,
      module: SystemModuleType.ReservedOrders,
      enforceRouteGuard: true,
    },
    5: {
      element: <DailyPage key="daily-income-page" canSelectDate={false} />,
      permission: Permissions.CanViewProfit,
      enforceRouteGuard: true,
    },
    6: {
      element: <DailyPage key="month-income-page" canSelectDate={true} />,
      permission: Permissions.CanViewProfit,
      enforceRouteGuard: true,
    },
    7: {
      element: <EmployeeMetricsPage key="employee-metrics-page" />,
      permission: Permissions.CanViewProfit,
      enforceRouteGuard: true,
    },
    8: {
      element: <PayrollSummaryPage key="payroll-summary-page" />,
      permission: Permissions.CanViewProfit,
      enforceRouteGuard: true,
    },
    9: { element: <ProductsPage key="products-page" />, permission: Permissions.CanEditeProducts },
    11: { element: <ComboPage key="combos-page" />, permission: Permissions.CanEditeCombos },
    12: { element: <CategoryPage key="category-page" />, permission: Permissions.CanEditeCategories },
    13: { element: <AdditionalPage key="additional-page" />, permission: Permissions.CanEditeAddtionals },
    14: { element: <PromotionsPage key="promotions-page" />, permission: Permissions.CanEditePromotions },
    15: { element: <AwardsPage key="awards-page" />, permission: Permissions.CanEditeAwards },
    16: { element: <ExtraServicesPage key="extra-services-page" />, permission: Permissions.CanEditeExtraService },
    17: { element: <CouponsPage key="coupons-page" />, permission: Permissions.CanEditeCoupons },
    18: { element: <MyCompanyPage key="company-page" />, permission: Permissions.CanEditeCompany },
    19: { element: <EmployeesPage key="employees-page" />, permission: Permissions.CanEditeEmployee },
    20: {
      element: <CourierPartnersPage key="courier-partners-page" />,
      permission: Permissions.CanEditeCourier,
      module: SystemModuleType.Delivery,
      enforceRouteGuard: true,
    },
    21: { element: <HelpCenterPage key="help-center-page" />, permission: Permissions.CanEditeCompany },
    22: { element: <TutorialsPage key="tutorials-page" />, permission: Permissions.CanEditeCompany },
    23: { element: <SelectionPage key="selection-page" />, permission: Permissions.CanEditeAddtionals },
    24: { element: <NoticesPage key="notices-page" />, permission: Permissions.CanEditeNotices },
    25: { element: <PushNotificationsPage key="push-notifications-page" />, permission: Permissions.CanEditeCompany },
    26: {
      element: <PrintAutomationPage key="print-automation-page" />,
      permission: Permissions.CanEditeCompany,
      module: SystemModuleType.PrintAutomation,
      enforceRouteGuard: true,
    },
    27: {
      element: <MenuMetricsPage key="menu-metrics-page" />,
      permission: Permissions.CanViewProfit,
      enforceRouteGuard: true,
    },
    28: {
      element: <WhatsAppAutomationPage key="whatsapp-automation-page" />,
      permission: Permissions.CanEditeCompany,
      module: SystemModuleType.WhatsAppAutomation,
      enforceRouteGuard: true,
    },
    29: {
      element: <WhatsAppCrmPage key="whatsapp-crm-page" />,
      permission: Permissions.CanAnswerWhatsApp,
      module: SystemModuleType.WhatsAppCrm,
      enforceRouteGuard: true,
    },
    30: {
      element: <WhatsAppOfficialPage key="whatsapp-official-page" />,
      permission: Permissions.CanEditeCompany,
      module: SystemModuleType.WhatsAppOfficial,
      enforceRouteGuard: true,
    },
    31: {
      element: <PlansPage key="plans-page" />,
      permission: Permissions.CanEditeCompany,
      enforceRouteGuard: true,
    },
    32: {
      element: <ManualExternalOrdersPage key="manual-external-orders-page" />,
      permission: Permissions.CanEditeOrders,
      module: SystemModuleType.ManualExternalOrders,
      enforceRouteGuard: true,
    },
    33: {
      element: <AiIntegrationPage key="ai-integration-page" />,
      permission: Permissions.CanViewProfit,
      module: SystemModuleType.AiAgents,
      enforceRouteGuard: true,
    },
    34: {
      element: <StoreGroupsPage key="store-groups-page" />,
      permission: Permissions.CanEditeCompany,
      module: SystemModuleType.StoreGroups,
      enforceRouteGuard: true,
    },
    35: {
      element: <FiscalIntegrationPage key="fiscal-integration-page" />,
      permission: Permissions.CanEditeCompany,
      module: SystemModuleType.FiscalIntegration,
      enforceRouteGuard: true,
    },
    36: {
      element: <FiscalImportsPage key="fiscal-imports-page" />,
      permission: Permissions.CanEditeCompany,
      module: SystemModuleType.FiscalIntegration,
      enforceRouteGuard: true,
    },
    37: {
      element: <RespostaAiIntegrationPage key="resposta-ai-integration-page" />,
      permission: Permissions.CanEditeCompany,
      module: SystemModuleType.RespostaAi,
      enforceRouteGuard: true,
    },
    38: {
      element: <MyTimeClockPage key="my-time-clock-page" />,
      module: SystemModuleType.TimeClock,
      enforceRouteGuard: true,
    },
    39: {
      element: <TimeClockPage key="time-clock-page" />,
      permission: Permissions.CanEditeTimeClock,
      module: SystemModuleType.TimeClock,
      enforceRouteGuard: true,
    },
    40: {
      element: <MyChecklistsPage key="my-checklists-page" />,
      permission: Permissions.CanExecuteChecklists,
      module: SystemModuleType.Checklists,
      enforceRouteGuard: true,
    },
    41: {
      element: <ChecklistPage key="checklists-page" />,
      permission: Permissions.CanManageChecklists,
      module: SystemModuleType.Checklists,
      enforceRouteGuard: true,
    },
  }

  const menu1 = new ObjectNavbarMenu(t("label_title_commands"), faScroll, "interactionDescriptions:components.navbar.navbar.navigation.category.orders")

  menu1.addMenu(0, t("label_commands"), faReceipt, PATH_MAP.COMMANDS_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.orders", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.orders")
  menu1.addMenu(
    1,
    t("label_servicePoints"),
    faLocationDot,
    PATH_MAP.SERVICE_POINTS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.tables",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.tables",
    Permissions.CanEditeServicePoints,
  )
  menu1.addMenu(
    32,
    t("label_manual_external_orders"),
    faFileInvoiceDollar,
    PATH_MAP.MANUAL_EXTERNAL_ORDERS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.manualExternalOrders",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.manualExternalOrders",
    Permissions.CanEditeOrders,
    SystemModuleType.ManualExternalOrders,
  )
  menu1.addMenu(2, t("label_customers"), faPeopleGroup, PATH_MAP.CUSTOMER_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.customers", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.customers")
  menu1.addMenu(
    3,
    t("label_customer_exit_check"),
    faUserCheck,
    PATH_MAP.CUSTOMER_EXIT_CHECK_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.customerExitCheck",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.customerExitCheck",
    undefined,
    SystemModuleType.CustomerExitCheck,
  )
  menu1.addMenu(
    4,
    t("label_reserved_orders"),
    faCalendarCheck,
    PATH_MAP.RESERVED_ORDERS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.reservedOrders",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.reservedOrders",
    Permissions.CanEditeOrders,
    SystemModuleType.ReservedOrders,
  )

  const menu5 = new ObjectNavbarMenu(t("label_title_money"), faCashRegister, "interactionDescriptions:components.navbar.navbar.navigation.category.finance")

  menu5.addMenu(
    5,
    t("label_today_money"),
    faMoneyBill,
    PATH_MAP.DAILY_INCOME_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.dailyIncome",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.dailyIncome",
    Permissions.CanViewProfit,
  )
  menu5.addMenu(
    6,
    t("label_moth_money"),
    faMoneyBill1Wave,
    PATH_MAP.MONTH_INCOME_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.monthIncome",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.monthIncome",
    Permissions.CanViewProfit,
  )
  menu5.addMenu(
    7,
    t("label_employee_metrics"),
    faUsers,
    PATH_MAP.EMPLOYEE_METRICS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.employeeMetrics",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.employeeMetrics",
    Permissions.CanViewProfit,
  )
  menu5.addMenu(
    8,
    t("label_payroll_summary"),
    faWallet,
    PATH_MAP.PAYROLL_SUMMARY_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.payrollSummary",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.payrollSummary",
    Permissions.CanViewProfit,
  )
  menu5.addMenu(
    27,
    t("label_menu_metrics"),
    faChartColumn,
    PATH_MAP.MENU_METRICS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.menuMetrics",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.menuMetrics",
    Permissions.CanViewProfit,
  )

  const menu12 = new ObjectNavbarMenu(t("label_title_fiscal"), faFileInvoiceDollar, "interactionDescriptions:components.navbar.navbar.navigation.category.fiscal")

  menu12.addMenu(
    35,
    t("label_fiscal_integration_menu"),
    faFileInvoiceDollar,
    PATH_MAP.FISCAL_INTEGRATION_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.fiscalIntegration",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.fiscalIntegration",
    Permissions.CanEditeCompany,
    SystemModuleType.FiscalIntegration,
  )

  menu12.addMenu(
    36,
    t("label_fiscal_imports_menu"),
    faFileImport,
    PATH_MAP.FISCAL_IMPORTS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.fiscalImports",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.fiscalImports",
    Permissions.CanEditeCompany,
    SystemModuleType.FiscalIntegration,
  )

  const menu2 = new ObjectNavbarMenu(t("label_title_products"), faProjectDiagram, "interactionDescriptions:components.navbar.navbar.navigation.category.products")

  menu2.addMenu(9, t("label_products"), faStore, PATH_MAP.PRODUCTS_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.meals", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.meals")
  menu2.addMenu(11, t("label_combo"), faObjectGroup, PATH_MAP.COMBO_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.combos", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.combos")
  menu2.addMenu(12, t("label_category"), faLayerGroup, PATH_MAP.CATEGORY_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.categories", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.categories")
  menu2.addMenu(13, t("label_addtionals"), faPlusSquare, PATH_MAP.ADDTIONAL_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.additionals", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.additionals")
  menu2.addMenu(23, t("label_selection"), faListCheck, PATH_MAP.SELECTION_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.selections", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.selections")

  const menu3 = new ObjectNavbarMenu(t("label_title_services"), faList, "interactionDescriptions:components.navbar.navbar.navigation.category.services")

  menu3.addMenu(14, t("label_promotions"), faRectangleAd, PATH_MAP.PROMOTIONS_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.promotions", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.promotions", undefined, SystemModuleType.Promotions)
  menu3.addMenu(15, t("label_awards"), faAward, PATH_MAP.AWARDS_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.awards", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.awards", undefined, SystemModuleType.Awards)
  menu3.addMenu(16, t("label_extra_services"), faBellConcierge, PATH_MAP.SERVICES_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.extraServices", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.extraServices", undefined, SystemModuleType.ExtraServices)
  menu3.addMenu(17, t("label_coupons"), faTicket, PATH_MAP.COUPONS_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.coupons", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.coupons", undefined, SystemModuleType.Coupons)
  menu3.addMenu(24, t("label_notices"), faBullhorn, PATH_MAP.NOTICES_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.notices", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.notices", undefined, SystemModuleType.Notices)

  const menu4 = new ObjectNavbarMenu(t("label_title_company"), faHouse, "interactionDescriptions:components.navbar.navbar.navigation.category.company")

  menu4.addMenu(18, t("label_data_company"), faSliders, PATH_MAP.COMPANY_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.company", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.company")
  menu4.addMenu(34, t("label_store_groups"), faStore, PATH_MAP.STORE_GROUPS_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.storeGroups", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.storeGroups", Permissions.CanEditeCompany, SystemModuleType.StoreGroups)
  menu4.addMenu(19, t("label_employees"), faUsers, PATH_MAP.EMPLOYEES_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.employees", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.employees")
  menu4.addMenu(26, t("label_print_automation_menu"), faPrint, PATH_MAP.PRINT_AUTOMATION_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.printAutomation", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.printAutomation", Permissions.CanEditeCompany, SystemModuleType.PrintAutomation)

  const menu13 = new ObjectNavbarMenu(
    t("label_title_time_clock"),
    faClock,
    "interactionDescriptions:components.navbar.navbar.navigation.category.timeClock",
  )

  if (timeClockStatus?.isEnabled) {
    menu13.addMenu(
      38,
      t("label_my_time_clock"),
      faFingerprint,
      PATH_MAP.MY_TIME_CLOCK_PAGE,
      "interactionDescriptions:components.navbar.navbar.navigation.destination.myTimeClock",
      "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.myTimeClock",
      undefined,
      SystemModuleType.TimeClock,
    )
  }

  menu13.addMenu(
    39,
    t("label_time_clock"),
    faUserClock,
    PATH_MAP.TIME_CLOCK_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.timeClock",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.timeClock",
    Permissions.CanEditeTimeClock,
    SystemModuleType.TimeClock,
  )

  const menu14 = new ObjectNavbarMenu(
    t("label_title_checklists"),
    faClipboardCheck,
    "interactionDescriptions:components.navbar.navbar.navigation.category.checklists",
  )

  menu14.addMenu(
    40,
    t("label_my_checklists"),
    faClipboardList,
    PATH_MAP.MY_CHECKLISTS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.myChecklists",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.myChecklists",
    Permissions.CanExecuteChecklists,
    SystemModuleType.Checklists,
  )

  menu14.addMenu(
    41,
    t("label_checklists"),
    faClipboardCheck,
    PATH_MAP.CHECKLISTS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.checklists",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.checklists",
    Permissions.CanManageChecklists,
    SystemModuleType.Checklists,
  )

  const menu6 = new ObjectNavbarMenu(t("label_title_delivery"), faMotorcycle, "interactionDescriptions:components.navbar.navbar.navigation.category.delivery")

  menu6.addMenu(
    20,
    t("label_delivery_partners"),
    faMotorcycle,
    PATH_MAP.COURIER_PARTNERS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.courierPartners",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.courierPartners",
    Permissions.CanEditeCourier,
    SystemModuleType.Delivery,
  )

  const menu7 = new ObjectNavbarMenu(t("label_title_help"), faCircleQuestion, "interactionDescriptions:components.navbar.navbar.navigation.category.help")

  menu7.addMenu(21, t("label_help_center"), faCircleQuestion, PATH_MAP.HELP_CENTER_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.helpCenter", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.helpCenter")
  menu7.addMenu(25, t("label_push_notifications"), faBell, PATH_MAP.PUSH_NOTIFICATIONS_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.pushNotifications", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.pushNotifications", undefined, SystemModuleType.PushNotifications)

  const menu8 = new ObjectNavbarMenu(t("label_title_tutorials"), faGraduationCap, "interactionDescriptions:components.navbar.navbar.navigation.category.tutorials")

  menu8.addMenu(22, t("label_tutorials"), faGraduationCap, PATH_MAP.TUTORIALS_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.tutorials", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.tutorials")

  const menu9 = new ObjectNavbarMenu(t("label_title_whatsapp"), faWhatsapp, "interactionDescriptions:components.navbar.navbar.navigation.category.whatsApp")

  menu9.addMenu(28, t("label_whatsapp_agent_menu"), faWhatsapp, PATH_MAP.WHATSAPP_AUTOMATION_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.whatsAppAutomation", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.whatsAppAutomation", Permissions.CanEditeCompany, SystemModuleType.WhatsAppAutomation)
  menu9.addMenu(
    29,
    t("label_whatsapp_crm_menu"),
    faRobot,
    PATH_MAP.WHATSAPP_CRM_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.whatsAppCrm",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.whatsAppCrm",
    Permissions.CanAnswerWhatsApp,
    SystemModuleType.WhatsAppCrm,
  )
  menu9.addMenu(30, t("label_whatsapp_official_menu"), faFacebook, PATH_MAP.WHATSAPP_OFFICIAL_PAGE, "interactionDescriptions:components.navbar.navbar.navigation.destination.whatsAppOfficial", "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.whatsAppOfficial", Permissions.CanEditeCompany, SystemModuleType.WhatsAppOfficial)
  menu9.addMenu(
    37,
    t("label_resposta_ai_menu"),
    faPlugCircleBolt,
    PATH_MAP.RESPOSTA_AI_INTEGRATION_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.respostaAiIntegration",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.respostaAiIntegration",
    Permissions.CanEditeCompany,
    SystemModuleType.RespostaAi,
  )

  const menu10 = new ObjectNavbarMenu(t("label_title_plans"), faCreditCard, "interactionDescriptions:components.navbar.navbar.navigation.category.plans")

  menu10.addMenu(
    31,
    t("label_plans_menu"),
    faCreditCard,
    PATH_MAP.PLANS_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.plans",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.plans",
    Permissions.CanEditeCompany,
  )

  const menu11 = new ObjectNavbarMenu(t("label_title_ai_agents"), faWandMagicSparkles, "interactionDescriptions:components.navbar.navbar.navigation.category.ai")

  menu11.addMenu(
    33,
    t("label_ai_integration_settings_menu"),
    faBrain,
    PATH_MAP.AI_INTEGRATION_PAGE,
    "interactionDescriptions:components.navbar.navbar.navigation.destination.aiIntegration",
    "interactionDescriptions:components.mobileBottomNavbar.mobileBottomNavbar.navigation.aiIntegration",
    Permissions.CanViewProfit,
    SystemModuleType.AiAgents,
  )

  const listRoutesToNav = [menu1, menu5, menu2, menu3, menu4, menu13, menu14, menu12, menu9, menu11, menu6, menu10, menu7, menu8]

  const location = useLocation()

  const pathToIndexMap: Record<string, number> = {
    [PATH_MAP.COMMANDS_PAGE]: 0,
    [PATH_MAP.SERVICE_POINTS_PAGE]: 1,
    [PATH_MAP.CUSTOMER_PAGE]: 2,
    [PATH_MAP.CUSTOMER_EXIT_CHECK_PAGE]: 3,
    [PATH_MAP.RESERVED_ORDERS_PAGE]: 4,
    [PATH_MAP.MANUAL_EXTERNAL_ORDERS_PAGE]: 32,
    [PATH_MAP.DAILY_INCOME_PAGE]: 5,
    [PATH_MAP.MONTH_INCOME_PAGE]: 6,
    [PATH_MAP.EMPLOYEE_METRICS_PAGE]: 7,
    [PATH_MAP.PAYROLL_SUMMARY_PAGE]: 8,
    [PATH_MAP.MENU_METRICS_PAGE]: 27,
    [PATH_MAP.PRODUCTS_PAGE]: 9,
    [PATH_MAP.COMBO_PAGE]: 11,
    [PATH_MAP.CATEGORY_PAGE]: 12,
    [PATH_MAP.ADDTIONAL_PAGE]: 13,
    [PATH_MAP.PROMOTIONS_PAGE]: 14,
    [PATH_MAP.AWARDS_PAGE]: 15,
    [PATH_MAP.SERVICES_PAGE]: 16,
    [PATH_MAP.COUPONS_PAGE]: 17,
    [PATH_MAP.COMPANY_PAGE]: 18,
    [PATH_MAP.EMPLOYEES_PAGE]: 19,
    [PATH_MAP.COURIER_PARTNERS_PAGE]: 20,
    [PATH_MAP.HELP_CENTER_PAGE]: 21,
    [PATH_MAP.TUTORIALS_PAGE]: 22,
    [PATH_MAP.SELECTION_PAGE]: 23,
    [PATH_MAP.NOTICES_PAGE]: 24,
    [PATH_MAP.PUSH_NOTIFICATIONS_PAGE]: 25,
    [PATH_MAP.PRINT_AUTOMATION_PAGE]: 26,
    [PATH_MAP.WHATSAPP_AUTOMATION_PAGE]: 28,
    [PATH_MAP.WHATSAPP_CRM_PAGE]: 29,
    [PATH_MAP.WHATSAPP_OFFICIAL_PAGE]: 30,
    [PATH_MAP.PLANS_PAGE]: 31,
    [PATH_MAP.AI_INTEGRATION_PAGE]: 33,
    [PATH_MAP.STORE_GROUPS_PAGE]: 34,
    [PATH_MAP.FISCAL_INTEGRATION_PAGE]: 35,
    [PATH_MAP.FISCAL_IMPORTS_PAGE]: 36,
    [PATH_MAP.RESPOSTA_AI_INTEGRATION_PAGE]: 37,
    [PATH_MAP.MY_TIME_CLOCK_PAGE]: 38,
    [PATH_MAP.TIME_CLOCK_PAGE]: 39,
    [PATH_MAP.MY_CHECKLISTS_PAGE]: 40,
    [PATH_MAP.CHECKLISTS_PAGE]: 41,
  }

  const indexPage = pathToIndexMap[location.pathname] ?? 0

  const activePage = pages[indexPage] ?? pages[0]

  const isActivePageBlocked = Boolean(activePage.enforceRouteGuard) &&
    !canAccessRestrictedPage(activePage.permission, activePage.module, userEmployee?.permissions, isModuleEnabled)

  useEffect(() => {
    if (hasLoadedInitialMemory.current) {
      return
    }

    hasLoadedInitialMemory.current = true

    void handleReloadToMemoryRef.current().finally(() => setPublicStoreLink(getPublicStoreLink()))
  }, [])

  useEffect(() => {
    if (hasRequestedTimeClockStatusRef.current) {
      return
    }

    hasRequestedTimeClockStatusRef.current = true

    void refreshTimeClockStatus()
  }, [refreshTimeClockStatus])

  useEffect(() => {
    if (!userEmployee?.isMaster || requiresOwnerProfile) {
      return
    }

    if (!userEmployee.hasCompletedModuleSetup && !hasRequestedModuleSetupRef.current) {
      hasRequestedModuleSetupRef.current = true
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsModuleSetupOpen(true)
      void refreshCompanyModulesStatus()
    }
  }, [
    refreshCompanyModulesStatus,
    requiresOwnerProfile,
    userEmployee?.hasCompletedModuleSetup,
    userEmployee?.isMaster,
  ])

  useEffect(() => {
    const handleOpenTutorial = () => {
      setIsOwnerOnboardingIntroOpen(false)
      setIsOwnerTutorialOpen(true)
    }

    window.addEventListener("open-owner-onboarding", handleOpenTutorial)

    return () => window.removeEventListener("open-owner-onboarding", handleOpenTutorial)
  }, [])

  useEffect(() => {
    if (!userEmployee?.isMaster || requiresOwnerProfile || !userEmployee.hasCompletedModuleSetup || isModuleSetupOpen) {
      return
    }

    if (!userEmployee.hasCompletedOwnerOnboarding && !hasRequestedOwnerTutorialRef.current) {
      hasRequestedOwnerTutorialRef.current = true
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsOwnerTutorialOpen(true)
      setIsOwnerOnboardingIntroOpen(true)
    }
  }, [
    isModuleSetupOpen,
    requiresOwnerProfile,
    userEmployee?.hasCompletedModuleSetup,
    userEmployee?.hasCompletedOwnerOnboarding,
    userEmployee?.isMaster,
  ])

  const handleCloseModuleSetup = () => {
    setIsModuleSetupOpen(false)

    if (!userEmployee?.isMaster || userEmployee.hasCompletedModuleSetup) {
      return
    }

    const updatedEmployee = new Employee({ ...userEmployee, hasCompletedModuleSetup: true })

    setEmployee(updatedEmployee)

    void PostRequest<boolean>(API_ROUTES.EMPLOYEE.COMPLETE_MODULE_SETUP, {}).catch(() => setEmployee(userEmployee))
  }

  const handleCloseOwnerTutorial = () => {
    setIsOwnerOnboardingIntroOpen(false)
    setIsOwnerTutorialOpen(false)

    if (!userEmployee?.isMaster || userEmployee.hasCompletedOwnerOnboarding) {
      return
    }

    const updatedEmployee = new Employee({ ...userEmployee, hasCompletedOwnerOnboarding: true })

    setEmployee(updatedEmployee)

    void PostRequest<boolean>(API_ROUTES.EMPLOYEE.COMPLETE_OWNER_ONBOARDING, {}).catch(() => setEmployee(userEmployee))
  }

  const handleStartOwnerTutorial = () => {
    setIsOwnerOnboardingIntroOpen(false)
    setIsOwnerTutorialOpen(true)
    window.dispatchEvent(new Event(OWNER_ONBOARDING_START_EVENT))
  }

  const handleMenuClick = () => {}

  return (
    <>
      <NavBarGlobal
        isPublicLink={false}
        listObjectNavBarMenu={listRoutesToNav}
        onMenuClick={handleMenuClick}
        externalButton={
          publicStoreLink.length > 0
            ? {
                title: t("label_view_store"),
                icon: faExternalLinkAlt,
                url: publicStoreLink,
                descriptionKey: "interactionDescriptions:components.navbar.navbar.navigation.external.publicMenu",
              }
            : undefined
        }
      />

      <div className={style.HomePageContainer}>
        <MenuLogged />

        <div className={style.pageContent}>
          {isActivePageBlocked ? <Navigate to={PATH_MAP.COMMANDS_PAGE} replace /> : activePage.element}
        </div>

        {!isNotMobile && <MobileBottomNavbar menus={listRoutesToNav.flatMap((e) => e.listMenus)} />}

        {timeClockStatus?.isEnabled && location.pathname === PATH_MAP.MY_TIME_CLOCK_PAGE && (
          <TimeClockStatusBar status={timeClockStatus} />
        )}

        <OwnerOnboardingTutorial open={isOwnerTutorialOpen} onClose={handleCloseOwnerTutorial} />

        <CompleteOwnerProfilePopup open={requiresOwnerProfile} />

        <CompanyModulesPopup open={isModuleSetupOpen} onClose={handleCloseModuleSetup} />

        <OwnerOnboardingIntroModal
          open={isOwnerOnboardingIntroOpen}
          onClose={() => setIsOwnerOnboardingIntroOpen(false)}
          onStartTutorial={handleStartOwnerTutorial}
          onSkipTutorial={handleCloseOwnerTutorial}
        />
      </div>
    </>
  )
}
